import { render, staticRenderFns } from "./UserSuspension.vue?vue&type=template&id=7217c746"
import script from "./UserSuspension.vue?vue&type=script&lang=js"
export * from "./UserSuspension.vue?vue&type=script&lang=js"
import style0 from "./UserSuspension.vue?vue&type=style&index=0&id=7217c746&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports